import React from 'react'
import Loadable from 'react-loadable'

import LoginHigherOrder from '../common/loginComponent'
import LoadingComponent from '../common/loadingComponent'


const WeeklyColumnsDashboard = Loadable({
  loader: () => import(/*webpackChunkName: 'chunk'*/'./dashboard'),
  loading: () => <LoadingComponent />
});

const Dashboard = (props) => {
  return <WeeklyColumnsDashboard secondTable={props.secondTable} />
}

export default LoginHigherOrder(Dashboard)